// preHide.js — blocking, end of <body>. Applies stored hidden threads +
// media files BEFORE first paint. Runs after all content is parsed (unlike
// staffModeEarly.js which fires right after <body> opens). External file on
// purpose: CSP is 'self' + hashes only.
try {
  // Hidden media files
  var _hm = localStorage.getItem('hiddenMedia');
  if (_hm) {
    var _names = JSON.parse(_hm);
    if (_names.length) {
      var _links = document.getElementsByClassName('imgLink');
      for (var _i = 0; _i < _links.length; _i++) {
        for (var _j = 0; _j < _names.length; _j++) {
          if (_links[_i].href.indexOf(_names[_j]) > -1) {
            _links[_i].style.display = 'none';
            // Set cell width now so it doesn't flash wide (filename-sized)
            // before deferred thumbs.js sets --thumbfit-w.
            var _cell = _links[_i].parentNode;
            while (_cell && _cell.tagName !== 'FIGURE') _cell = _cell.parentNode;
            if (_cell) {
              var _img = _links[_i].querySelector('img');
              if (_img && _img.width) {
                var _w = Math.min(_img.width, 200);
                if (_img.height > 200) _w = Math.min(_w, Math.floor(200 * _img.width / _img.height));
                _cell.style.setProperty('--thumbfit-w', _w + 'px');
              }
            }
            break;
          }
        }
      }
    }
  }

  // Hidden threads/posts
  var _hd = localStorage.getItem('hidingData');
  if (_hd) {
    var _data = JSON.parse(_hd);
    var _selfs = document.getElementsByClassName('linkSelf');
    for (var _i = 0; _i < _selfs.length; _i++) {
      var _href = _selfs[_i].href;
      var _parts = _href.split('/');
      var _board = _parts[3];
      var _bd = _data[_board];
      if (!_bd) continue;
      var _tid = (_parts[5] || '').split('.')[0];
      var _pid = (_href.split('#')[1]) || '';
      var _hide = false;
      if (_bd.threads && _bd.threads.indexOf(_tid) > -1) _hide = true;
      if (!_hide && _pid && _pid !== _tid && _bd.posts && _bd.posts.indexOf(_pid) > -1) _hide = true;
      if (_hide) {
        var _cell = _selfs[_i].closest('.opCell, .postCell');
        if (_cell) _cell.classList.add('hidden');
      }
    }
  }
} catch (e) { /* private mode / storage disabled — deferred scripts settle it */ }

// Excluded posts — the engine stamps cells belonging to excluded authors
// with data-lz="1" (an ordinary lazy-load flag). Hide them from everyone
// except the author's own browser, recognized by comparing the posting values
// this site persists in localStorage (name / deletionPassword /
// postingPasswords) and the ui_pref cookie their last post set against a list
// of hashes — values are lowercased before hashing, so casing doesn't matter —
// and staff with the 'showHiddenPosts' setting on; staffNavRole is only ever
// set by staffNav.js after a server-verified account fetch, so non-staff
// setting the flag by hand changes nothing.
function _sha256Hex(str) {
  var K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1,
    0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786,
    0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
    0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b,
    0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a,
    0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];
  var rotr = function(x, n) { return (x >>> n) | (x << (32 - n)); };
  var bytes = [];
  for (var i = 0; i < str.length; i++) {
    var ch = str.charCodeAt(i);
    if (ch < 0x80) bytes.push(ch);
    else if (ch < 0x800) bytes.push(0xc0 | (ch >> 6), 0x80 | (ch & 0x3f));
    else bytes.push(0xe0 | (ch >> 12), 0x80 | ((ch >> 6) & 0x3f), 0x80 | (ch & 0x3f));
  }
  var bitLen = bytes.length * 8;
  bytes.push(0x80);
  while (bytes.length % 64 !== 56) bytes.push(0);
  for (var b = 7; b >= 0; b--) bytes.push((bitLen / Math.pow(2, 8 * b)) & 0xff);
  var H = [ 0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
            0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19 ];
  for (var off = 0; off < bytes.length; off += 64) {
    var w = new Array(64);
    for (var t = 0; t < 16; t++) {
      w[t] = (bytes[off + t * 4] << 24) | (bytes[off + t * 4 + 1] << 16) |
             (bytes[off + t * 4 + 2] << 8) | bytes[off + t * 4 + 3];
    }
    for (var t = 16; t < 64; t++) {
      var s0 = rotr(w[t - 15], 7) ^ rotr(w[t - 15], 18) ^ (w[t - 15] >>> 3);
      var s1 = rotr(w[t - 2], 17) ^ rotr(w[t - 2], 19) ^ (w[t - 2] >>> 10);
      w[t] = (w[t - 16] + s0 + w[t - 7] + s1) | 0;
    }
    var a = H[0], b = H[1], c = H[2], d = H[3], e = H[4], f = H[5], g = H[6], h = H[7];
    for (var t = 0; t < 64; t++) {
      var S1 = rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25);
      var ch2 = (e & f) ^ (~e & g);
      var T1 = (h + S1 + ch2 + K[t] + w[t]) | 0;
      var S0 = rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22);
      var maj = (a & b) ^ (a & c) ^ (b & c);
      var T2 = (S0 + maj) | 0;
      h = g; g = f; f = e; e = (d + T1) | 0; d = c; c = b; b = a; a = (T1 + T2) | 0;
    }
    H[0] = (H[0] + a) | 0; H[1] = (H[1] + b) | 0; H[2] = (H[2] + c) | 0; H[3] = (H[3] + d) | 0;
    H[4] = (H[4] + e) | 0; H[5] = (H[5] + f) | 0; H[6] = (H[6] + g) | 0; H[7] = (H[7] + h) | 0;
  }
  var out = '';
  for (var i = 0; i < 8; i++) {
    var hx = (H[i] >>> 0).toString(16);
    while (hx.length < 8) hx = '0' + hx;
    out += hx;
  }
  return out;
}
try {
  // Hashes of the lowercased exclusion list — keep in sync with the engine's
  // general.json (sha256 of each pattern, lowercased).
  var _filterHashes = [ '5db835afd88ce4705ad8f2c6d5a585a7c01c2d77f671fce8ec2a088560907926' ];
  // A fresh browser gets this many visits before exclusion applies to it.
  var _graceVisits = 15;
  var _exempt = false;
  var _check = function(value) {
    if (!value || _exempt) return;
    var v = String(value).toLowerCase();
    for (var i = 0; i < _filterHashes.length; i++) {
      if (_filterHashes[i] === v) { _exempt = true; return; }
    }
    var h = _sha256Hex(v);
    for (var j = 0; j < _filterHashes.length; j++) {
      if (_filterHashes[j] === h) { _exempt = true; return; }
    }
  };
  _check(localStorage.getItem('name'));
  _check(localStorage.getItem('deletionPassword'));
  var _ppRaw = localStorage.getItem('postingPasswords');
  if (_ppRaw) {
    var _pp = JSON.parse(_ppRaw);
    for (var _pk in _pp) {
      if (Object.prototype.hasOwnProperty.call(_pp, _pk)) {
        _check(_pp[_pk]);
      }
      if (_exempt) break;
    }
  }
  // Identity present in this browser's stored posting values (as opposed to
  // an exemption that came from a cookie or the staff flag).
  var _storedMatch = _exempt;
  // ui_pref cookie value (set on the author's last matching post)
  var _ck = document.cookie;
  if (_ck && !_exempt) {
    var _pairs = _ck.split('; ');
    for (var _ci = 0; _ci < _pairs.length; _ci++) {
      var _eq = _pairs[_ci].indexOf('=');
      if (_eq > -1 && _pairs[_ci].slice(0, _eq) === 'ui_pref') {
        _check(_pairs[_ci].slice(_eq + 1));
        break;
      }
    }
  }
  // Staff visibility override (Settings → 'See hidden posts').
  if (!_exempt && localStorage.getItem('staffNavRole') === 'staff' &&
      localStorage.getItem('showHiddenPosts') === 'true') {
    _exempt = true;
  }
  // Visit counter: while this browser is under the grace threshold it sees
  // everything; once past it, exclusion applies unless an exemption above
  // (or a ui_pref set by a matching post) covers it.
  var _vis = parseInt(localStorage.getItem('ui_vis'), 10);
  if (isNaN(_vis)) _vis = 0;
  _vis += 1;
  localStorage.setItem('ui_vis', String(_vis));
  // During grace, a browser that already carries the author's values keeps
  // working after they are cleared: pin the exemption in the ui_pref cookie
  // (value = one of the list hashes — the check above accepts it as-is).
  if (_vis < _graceVisits && _storedMatch) {
    document.cookie = 'ui_pref=' + _filterHashes[0] + '; max-age=31536000; path=/';
  }
  // Hide only once this browser is past the grace threshold and no exemption
  // (stored identity, ui_pref cookie, or staff flag) covers it.
  if (_vis >= _graceVisits && !_exempt) {
    var _cells = document.querySelectorAll('[data-lz]');
    for (var _c = 0; _c < _cells.length; _c++) {
      _cells[_c].classList.add('hidden');
    }
  }
  // Exposed for cells built after this script runs (dynamic feeds): the
  // builder stamps data-lz from its own data and applies .hidden itself when
  // this is true — same decision, one place it is made.
  window.lzActive = (_vis >= _graceVisits) && !_exempt;
} catch (e) { /* storage disabled — cells stay visible, nothing breaks */ }
